import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import classes from './AboutUsHero.module.scss'

export const AboutUsHero = () => {
  return (
    <Block
      as={'section'}
      variant={'shadow'}
      pad={'base'}
      className={classes.section}
    >
      <Heading as={'h1'} center balance size={'xxl'} className={classes.title}>
        Software apps still work in isolation.
        <br />
        We enable them to communicate &amp;&nbsp;collaborate seamlessly
      </Heading>
    </Block>
  )
}
